import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactGA from 'react-ga';


function QRcodegenerate() {
  const [QRval, setQRval] = useState("");

  const generateQR = (value) => {
    setQRval(value);
  };

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);  // google analytics pageview
  },[])


  // image download fxn
  const downloadImage = () => {
    const svg = document.getElementById("QRCode");
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");

      downloadLink.download = "qrcode";
      downloadLink.href = `${pngFile}`;
      downloadLink.click();
    };
    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      <div className="d-flex flex-column-reverse">
        <div>
          <h1 className="display-1 font-weight-bold">QR Ledger</h1>
          <p>Minify your portfolio into a QR code...</p>
        </div>
        <div className="p-3">
          <img
            src={require("../assets/pocus-qr-code.png")}
            alt="intro-img"
          />
        </div>
      </div>
      {QRval !== "" ? (
        <div>
          <QRCode size={256} value={QRval} id="QRCode" />
        </div>
      ) : (
        <div></div>
      )}

      <div className="">
        <input
          type="text"
          required
          className="form-control m-2"
          placeholder="paste link here..."
          onChange={(e) => generateQR(e.target.value)}
        />
      </div>
      {QRval !== "" ? (
        <div className="mb-4">
          <input
            className="btn btn-primary text-white p-1"
            type="button"
            onClick={downloadImage}
            value="Download"
          />
          <Link to="bcard">
            <button className="btn btn-outline-dark p-1 mx-3">
              Generate Business Card{" "}
            </button>
          </Link>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

export default QRcodegenerate;
